var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpMethod, Service } from '../enums';
import { CUSTOMER_MOCK, MAIL_CONSENTS_MOCK } from '../mocks';
import { createHttpAction } from './utils';
export const getCustomerForLDClient = (customerId) => __awaiter(void 0, void 0, void 0, function* () {
    const req = {
        service: Service.CAS,
        url: '/customers/:customerId',
        settings: {
            pathParams: { customerId },
        },
    };
    const mock = {
        data: CUSTOMER_MOCK,
    };
    return createHttpAction(req, mock);
});
export const getCustomerMailConsents = () => __awaiter(void 0, void 0, void 0, function* () {
    const req = {
        service: Service.IS,
        url: '/mail/consents',
        method: HttpMethod.GET,
        settings: {
            withCredentials: true,
        },
    };
    const mock = { data: MAIL_CONSENTS_MOCK };
    return createHttpAction(req, mock);
});
//# sourceMappingURL=customer.js.map